<div class="ion-text-center popup-content">
  <span class="h1">Website Under Development</span>
  <p>This is a beta version of the website. You may encounter some minor bugs and content placeholders while browsing. We appreciate your patience and feedback! If you'd like to share your thoughts, reach out to zafer&#64;satelrealty.sa.</p>
  <a class="link-button primary round" (click)="modalController.dismiss()">Close</a>
</div>
